<input style="width: 100%;" [(ngModel)]="value" matInput [matDatepicker]="datepicker" style="width: 100%" [style.width.px]="width" [style.lineHeight]='lineHeight' />
<mat-datepicker #datepicker (opened)="onOpen()" (closed)=" closed()"></mat-datepicker>

<!-- Workaround for adding the buttons -->
<div style="display: none ">
    <div class="datepicker-footer" #datepickerFooter>
        <button mat-raised-button color="accent" #clearButton (click)="clear()">Clear</button>
    </div>
</div>